import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { BadgeComponent } from '@cintra-payroll-hr/components';

type BadgeColor = 'gray' | 'brand' | 'error' | 'warning' | 'success' | 'info';

const statusColorMap: Record<string, BadgeColor> = {
  due: 'warning',
  pending: 'gray',
  completed: 'success',
  complete: 'success',
  failed: 'error',
  'auth required': 'info',
  'authorization required': 'info'
};

@Component({
  selector: 'app-status-badge-cell-renderer',
  template: `
    @if (label) {
      <ci-badge [color]="color" size="md">{{ label }}</ci-badge>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        height: 100%;
      }
    `
  ],
  standalone: true,
  imports: [BadgeComponent]
})
export class StatusBadgeCellRendererComponent implements ICellRendererAngularComp {
  label: string | null = null;
  color: BadgeColor = 'gray';

  agInit(params: ICellRendererParams): void {
    this.updateConfig(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateConfig(params);
    return true;
  }

  private updateConfig(params: ICellRendererParams): void {
    const value = params.valueFormatted ?? params.value;
    if (!value) {
      this.label = null;
      return;
    }

    this.label = String(value);
    this.color = statusColorMap[this.label.toLowerCase()] ?? 'gray';
  }
}
